import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import lang from '../../lang/lang.json';
import './countdown.scss';

const CountDown = ({ handleOpen, handleGetSms }) => {
  const { language } = useSelector((state) => state.language);
  const [countDown, setCountDown] = useState(true);
  const [counter, setCounter] = useState(60);

  useEffect(() => {
    let timeout;
    if (counter > 0) {
      timeout = setTimeout(() => setCounter(counter - 1), 1000);
    } else {
      setCountDown(false);
      clearTimeout(timeout);
    }
  }, [counter, handleOpen]);

  const handleClickReset = () => {
    setCountDown(true);
    setCounter(60);
  };

  return (
    <div className="count-down-container">
      <div>
        {lang.PHONE_SMS_INPUT_CODE_AGAIN[language]} {counter}{' '}
        {lang.PHONE_SMS_INPUT_CODE_AGAIN_SEC[language]}.
      </div>
      <div className="count-background">
        <div
          className={`count-down-box ${countDown === true ? 'animate' : ''}`}
        ></div>
      </div>
      <div className="reset-counting" onClick={handleClickReset}>
        {counter <= 0 && (
          <div onClick={handleGetSms}>
            {lang.PHONE_SMS_CODE_AGAIN_BUTTON[language]}
          </div>
        )}
      </div>
    </div>
  );
};

export default CountDown;
